import { Wrench } from '@phosphor-icons/react';

import heruLogo from '@/assets/img/svg/heru-logo-v3.svg';

/**
 * Pantalla completa de «Estamos en mantenimiento». Estática a propósito: sin
 * rutas, sin Redux, sin llamadas a nuestras APIs ni eventos, porque se pinta
 * justo cuando el backend o la base pueden estar caídos. Sin enlace a WhatsApp:
 * durante el mantenimiento soporte también está caído.
 */
export const MaintenanceScreen = () => (
	<main
		role='status'
		className='bg-h-primary-95 flex min-h-dvh flex-col items-center justify-center px-6 py-10 text-center'>
		<img src={heruLogo} alt='heru' className='mb-10 h-7 w-auto object-contain' />
		<span className='bg-h-primary-90 grid size-16 place-items-center rounded-2xl'>
			<Wrench size={32} weight='fill' className='text-h-primary-50' aria-hidden />
		</span>
		<h1 className='text-h-text-heading mt-6 text-2xl font-bold md:text-3xl'>
			Estamos en mantenimiento
		</h1>
		<p className='text-h-text-medium mt-3 max-w-md text-base leading-relaxed'>
			Estamos haciendo mejoras en Heru. Vuelve a intentarlo más tarde.
		</p>
	</main>
);
